import { NgModule } from '@angular/core';
import { HttpModule, Http } from '@angular/http';
import { AppConfig, LoaderService, HttpIntegrationService } from './index';

@NgModule({
    imports: [HttpModule],
    declarations: [],
    providers: [AppConfig],
    exports: []
})
export class CoreModule {
}
